import type { DirectoryOffer } from './aggregate-releases'

export type PackedDirectoryOffer = [href: string, sellerName: number, sellerType: number]

export const packOffer = (offer: DirectoryOffer, word: (value: string) => number): PackedDirectoryOffer => [
  offer.href,
  word(offer.sellerName),
  word(offer.sellerType),
]

export const unpackOffer = (
  [href, sellerName, sellerType]: PackedDirectoryOffer,
  word: (value: number) => string
): DirectoryOffer => ({
  href,
  sellerName: word(sellerName),
  sellerType: word(sellerType),
})
